import React, { useEffect } from 'react';
import { useTheme as useNextTheme } from 'next-themes';
export function useTheme() {
  const { theme, setTheme, resolvedTheme } = useNextTheme();
  // Fix hydration mismatch or dispatcher issues by ensuring we only 
  // report theme on the client after mount if needed, but next-themes handles this.
  const isDark = resolvedTheme === 'dark';
  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };
  return { 
    isDark, 
    toggleTheme, 
    theme, 
    setTheme 
  };
}